import { render } from "./MenuSide.vue?vue&type=template&id=64624777"
import script from "./MenuSide.vue?vue&type=script&lang=js"
export * from "./MenuSide.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__